import React, { useState, useCallback } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import SelectTab from './share/SelectTab';
import JalBooking from './jal_booking/jal_booking';
import RakutenHotel from './rakuten_hotel/rakuten_hotel';
import AllHotels from './all_hotels/all_hotels';

const Tab = {
  JAL_BOOKING: 'JAL',
  RAKUTEN_HOTEL: '楽天ホテル',
  ALL_HOTELS: 'ホテルすべて'
} as const;
type TabType = keyof typeof Tab;

const AutoReservationInventory = observer(() => {
  const history = useHistory();
  const [currentTab, setCurrentTab] = useState<TabType>(
    (utils.getParam('sub_tab') as TabType) ||
      (utils.getParam('auto_reservation_inventory_tab') as TabType) ||
      'JAL_BOOKING'
  );

  const handleTabChange = useCallback(
    (tab: TabType) => {
      setCurrentTab(tab);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', tab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history]
  );

  return (
    <>
      <SelectTab tabs={Tab} currentTab={currentTab} onChange={handleTabChange} />
      {currentTab === 'JAL_BOOKING' && <JalBooking />}
      {currentTab === 'RAKUTEN_HOTEL' && <RakutenHotel />}
      {currentTab === 'ALL_HOTELS' && <AllHotels />}
    </>
  );
});

export default AutoReservationInventory;
